export default {
  currentSelectedHomepageLayoutId: null
};



// WEBPACK FOOTER //
// ./public/pages/EditHomepageLayoutsPage/initialState.js